import {
  AudienceSegmentActiveInactive,
  IAudienceSegment,
  ISamsungDMPAudienceSegmentPartner,
  transformAudienceSegment,
  transformSamsungDMPAudienceSegmentPartner,
} from '~/src/dash/api/console-api';
import { generateTokenParams, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';
import { IMenuList } from '~/src/dash/types/menuList';

interface SegmentPartnersResponse {
  samsungdmp_segment_partners?: ISamsungDMPAudienceSegmentPartner[];
}

export const targetingInactiveAudienceSegments = (
  segments: IAudienceSegment[],
  segmentIDs: string,
): boolean => {
  const ids = segmentIDs.split(',');
  for (const id of ids) {
    for (const segment of segments) {
      if (segment.ID === id && segment.Active === AudienceSegmentActiveInactive) {
        return true;
      }
    }
  }

  return false;
};

export async function getAudienceSegmentsMenuList(
  session: ISessionState,
): Promise<Record<string, IMenuList>> {
  const reqUrl = `${getApiDomain()}/v1/settings/segments?${generateTokenParams(
    session.publisher.ID,
  )}`;

  interface SegmentsResponse {
    segments?: IAudienceSegment[];
  }

  return await restGet<SegmentsResponse>(reqUrl, {})
    .then((val: IHttpResponse<SegmentsResponse>) => {
      const audienceSegments = val.parsedBody?.segments?.map(transformAudienceSegment) || [];
      return {
        audience_segments: generateCampaignMenuList(audienceSegments),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        audience_segments: {},
      };
    });
}

const generateSamsungDMPAudienceSegmentPartnerMenuList = (
  audienceSegmentPartners: ISamsungDMPAudienceSegmentPartner[],
): IMenuList => {
  const menuList: IMenuList = {};

  audienceSegmentPartners.forEach((audienceSegmentPartner: ISamsungDMPAudienceSegmentPartner) => {
    menuList[audienceSegmentPartner.SegmentPartner] = {
      ID: String(audienceSegmentPartner.SegmentPartner),
      selected: false,
      title: audienceSegmentPartner.SegmentPartner,
    };
  });

  return menuList;
};

export async function getSamsungDMPAudienceSegmentPartner(
  session: ISessionState,
): Promise<Record<string, ISamsungDMPAudienceSegmentPartner[]>> {
  const reqUrl = `${getApiDomain()}/v1/settings/samsungdmp_segment_partners?${generateTokenParams(
    session.publisher.ID,
  )}`;

  return await restGet<SegmentPartnersResponse>(reqUrl, {})
    .then((val: IHttpResponse<SegmentPartnersResponse>) => {
      const audienceSegmentPartners =
        val.parsedBody?.samsungdmp_segment_partners?.map(
          transformSamsungDMPAudienceSegmentPartner,
        ) || [];
      return {
        samsungdmp_segment_partners: audienceSegmentPartners,
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        samsungdmp_segment_partners: [],
      };
    });
}

export async function getSamsungDMPAudienceSegmentPartnerMenuList(
  session: ISessionState,
): Promise<Record<string, IMenuList>> {
  const reqUrl = `${getApiDomain()}/v1/settings/samsungdmp_segment_partners?${generateTokenParams(
    session.publisher.ID,
  )}`;

  return await restGet<SegmentPartnersResponse>(reqUrl, {})
    .then((val: IHttpResponse<SegmentPartnersResponse>) => {
      const audienceSegmentPartners =
        val.parsedBody?.samsungdmp_segment_partners?.map(
          transformSamsungDMPAudienceSegmentPartner,
        ) || [];
      return {
        samsungdmp_segment_partners:
          generateSamsungDMPAudienceSegmentPartnerMenuList(audienceSegmentPartners),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        samsungdmp_segment_partners: {},
      };
    });
}

const generateCampaignMenuList = (audienceSegments: IAudienceSegment[]): IMenuList => {
  const menuList: IMenuList = {};

  audienceSegments.forEach((audienceSegment: IAudienceSegment) => {
    menuList[audienceSegment.ID] = {
      ID: String(audienceSegment.ID),
      selected: false,
      title: audienceSegment.Name,
    };
  });

  return menuList;
};
